// extracted by mini-css-extract-plugin
export var breadcrumb = "component-module--breadcrumb--211bc";
export var breadcrumbWrapper = "component-module--breadcrumbWrapper--7942b";
export var btnFacebook = "component-module--btn-facebook--9da47";
export var btnLinkedin = "component-module--btn-linkedin--82894";
export var btnWechat = "component-module--btn-wechat--138fb";
export var btnXing = "component-module--btn-xing--8171e";
export var btnYoutube = "component-module--btn-youtube--2c9e3";
export var dark = "component-module--dark--0f1a8";
export var icon = "component-module--icon--41cdf";
export var iconText = "component-module--icon-text--3b87a";
export var mail = "component-module--mail--ff4ee";
export var phone = "component-module--phone--25dbc";
export var printer = "component-module--printer--7e0e3";